import { css } from "@emotion/css";

const styles = {
  container: (isMobile) => css`
    height: ${isMobile ? "calc(100vh - 50px)" : "100vh"};
  `,
  fabSection: css`
    bottom: 35px;
    right: 15px;
  `,
};

export default styles;
